import React from 'react'
import { Modal } from '@mui/material';
import { deleteMediaStyles as styles} from "./DeleteMediaModal.tailwind"
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../Button/Button';
import { useSelector } from 'react-redux';

const DeleteMediaModal = ({ isOpen, onClose, handleDelete }) => {
    const {deletingMessage: isDeleting} = useSelector(state => state.liveGame);
    console.log('isOpen: ', isOpen);
    

    return (
        <Modal
            open={isOpen}
            onClose={() => {}} // Prevent closing when clicking outside
            disableAutoFocus
        >
            <div className={styles.container}>
                <button onClick={onClose} className={styles.closeIcon}>
                    <CloseIcon sx={{ fontSize: "18px" }} />
                </button>
                <div className={styles.heading}>Confirm Delete</div>
                <div className={styles.description}>
                    <span className={styles.confirmationText}>Are you sure you want to delete the selected file ?</span>
                </div>
                <div className={styles.buttonContainer}>
                    <Button variant="primary" onClick={onClose} className={styles.button} disabled = {isDeleting}>
                        Cancel
                    </Button>
                    <Button variant="lighttheme" onClick={handleDelete} className={`${styles.button} ${styles.deleteButton}`} disabled = {isDeleting}>
                        {isDeleting ? `Deleting...` : 'Delete'}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteMediaModal